import { BaseScheduleShift } from '../BaseScheduleShift/BaseScheduleShift'
import { ShiftPlanning } from '../ShiftPlanning/ShiftPlanning'

export const sortPlannings = (plannings: ShiftPlanning[]): ShiftPlanning[] => (
    [...plannings].sort((a, b) => a.user.fullName.localeCompare(b.user.fullName))
)

export const mergePlanningIntoShift = (
    shift: BaseScheduleShift,
    planning: ShiftPlanning,
    replaceId?: string,
): BaseScheduleShift => ({
    ...shift,
    shiftPlannings: sortPlannings([
        ...shift.shiftPlannings.filter(p => p.id !== replaceId),
        planning,
    ]),
})